/**
 * SxS Network — Collection fitment chips + "Show only parts that fit" toggle (v1.1, 16 Oct 2026)
 * ------------------------------------------------------------------------------------------
 * Reads per-card fitment from <li data-sxsn-fd data-sxsn-uni> (sections/main-collection-product-grid.liquid)
 * and matches it against the PRIMARY garage machine with SxSNGarage.matchesDisplay() (garage-data.js v3).
 *
 * Card states:
 *   fits      → green chip "Fits your machine" (exact year) / "Listed for your model" (no year to check)
 *   universal → blue chip "Universal fit"
 *   nofit     → product HAS fitment data and your machine isn't on it → grey chip, card dimmed
 *   unknown   → product has no fitment data (brand doesn't publish it) → no chip, hidden when ON
 *   gear      → tagged "no-fitment" (apparel, helmets, tools) → no chip, never hidden
 * v1.1: fitment_display wins over the Universal tag; tags matched case-insensitively in Liquid.
 * Toggle ON = "Show only parts listed for my machine": only fits + universal stay visible, and the
 * script pulls the same collection's other pages (section rendering, max 30 pages) so the
 * fits from every page show here; pagination is hidden while on. OFF restores the normal page.
 * Garage data never leaves the device.
 */
(function () {
  var PREF_KEY = 'sxsn_fit_toggle_v1';
  var G = function () { return window.SxSNGarage; };

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function prefOn() { try { return localStorage.getItem(PREF_KEY) === '1'; } catch (e) { return false; } }
  function setPref(on) { try { localStorage.setItem(PREF_KEY, on ? '1' : '0'); } catch (e) {} }

  function primary() {
    var g = G(); if (!g) return null;
    return g.getPrimary() || (g.list()[0] || null);
  }

  function classify(li, machine) {
    var fd = li.getAttribute('data-sxsn-fd') || '';
    var uni = li.getAttribute('data-sxsn-uni') === '1';
    var nf = li.getAttribute('data-sxsn-nf') === '1';
    // v1.1: manufacturer fitment wins over the Universal tag; "no-fitment" tag = gear/apparel/tools (never hidden, no chip)
    if (fd.trim()) {
      var res = G().matchesDisplay(fd, false) || [];
      if (!(res.length && res[0].dataIncomplete)) {
        var hit = res.filter(function (r) { return r.machine && r.machine.id === machine.id; })[0];
        if (!hit) return { state: 'nofit' };
        return { state: 'fits', exact: hit.matchType === 'exact' };
      }
    }
    if (uni) return { state: 'universal' };
    if (nf) return { state: 'gear' };
    return { state: 'unknown' };
  }

  function chipHtml(c) {
    if (c.state === 'fits') {
      return '<span class="sxsn-fitchip sxsn-fitchip--fits"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg>'
        + (c.exact ? 'Fits your machine' : 'Listed for your model') + '</span>';
    }
    if (c.state === 'universal') return '<span class="sxsn-fitchip sxsn-fitchip--uni">Universal fit</span>';
    if (c.state === 'nofit') return '<span class="sxsn-fitchip sxsn-fitchip--no">Not for your machine</span>';
    return '';
  }

  function injectCss() {
    if (document.getElementById('sxsn-fitcol-css')) return;
    var css = ''
      + '#sxsn-fit-bar{margin:0 auto 16px;font-family:inherit}'
      + '#sxsn-fit-bar .sxsn-fb{display:flex;align-items:center;gap:14px;flex-wrap:wrap;background:#0f0f0f;color:#fff;border-radius:10px;padding:12px 16px;border:1px solid #2a2a2a}'
      + '#sxsn-fit-bar .sxsn-fb-ico{flex:0 0 auto;color:#ff5400;display:flex}'
      + '#sxsn-fit-bar .sxsn-fb-pic{flex:0 0 auto;width:56px;height:56px;border-radius:8px;object-fit:cover;border:2px solid #ff5400;background:#1d1d1d}'
      + '#sxsn-fit-bar .sxsn-fb-txt{flex:1 1 220px;font-size:15px;font-weight:700;line-height:1.3}'
      + '#sxsn-fit-bar .sxsn-fb-txt small{display:block;font-size:12.5px;font-weight:500;color:#bdbdbd;margin-top:2px}'
      + '#sxsn-fit-bar .sxsn-fb-sw{flex:0 0 auto;width:56px;height:32px;border-radius:16px;border:0;padding:0;position:relative;cursor:pointer;background:#555;transition:background .15s}'
      + '#sxsn-fit-bar .sxsn-fb-sw[aria-checked="true"]{background:#ff5400}'
      + '#sxsn-fit-bar .sxsn-fb-sw span{position:absolute;top:4px;left:4px;width:24px;height:24px;border-radius:12px;background:#fff;transition:left .15s}'
      + '#sxsn-fit-bar .sxsn-fb-sw[aria-checked="true"] span{left:28px}'
      + '#sxsn-fit-bar .sxsn-fb-sw:focus-visible{outline:2px solid #fff;outline-offset:2px}'
      + '#sxsn-fit-bar a.sxsn-fb-cta{flex:0 0 auto;background:#ff5400;color:#000;font-weight:800;font-size:14px;text-decoration:none;border-radius:6px;padding:11px 16px;min-height:44px;display:inline-flex;align-items:center}'
      + '#sxsn-fit-bar a.sxsn-fb-link{color:#ff5400;font-weight:700;font-size:13px;text-decoration:underline}'
      + 'li.grid__item[data-sxsn-fd]{position:relative}'
      + '.sxsn-fitchip{position:absolute;top:8px;left:8px;z-index:3;display:inline-flex;align-items:center;gap:5px;padding:5px 9px;border-radius:4px;'
      +   'font-size:11.5px;font-weight:800;letter-spacing:.04em;text-transform:uppercase;line-height:1.1;pointer-events:none;box-shadow:0 1px 3px rgba(0,0,0,.25)}'
      + '.sxsn-fitchip--fits{background:#1f8a44;color:#fff}'
      + '.sxsn-fitchip--uni{background:#3a6dbd;color:#fff}'
      + '.sxsn-fitchip--no{background:#ece9e4;color:#555;box-shadow:none}'
      + 'li.sxsn-fit-nofit{opacity:.55}'
      + 'body.sxsn-fit-on li.sxsn-fit-nofit,body.sxsn-fit-on li.sxsn-fit-unknown{display:none!important}'
      + 'body:not(.sxsn-fit-on) li[data-sxsn-extra]{display:none!important}'
      + 'body.sxsn-fit-on #ProductGridContainer .pagination-wrapper{display:none!important}'
      + '#sxsn-fit-bar .sxsn-fb-empty{margin:12px 0 0;padding:14px 16px;border:1px dashed #bbb;border-radius:8px;font-size:14px;color:#333;background:#faf9f7}';
    var st = document.createElement('style');
    st.id = 'sxsn-fitcol-css';
    st.textContent = css;
    document.head.appendChild(st);
  }

  var CAR = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 13l2-5h14l2 5v5h-3m-12 0H3v-5m3 5a2 2 0 104 0m4 0a2 2 0 104 0"/></svg>';

  function renderBar(machine, counts) {
    var bar = document.getElementById('sxsn-fit-bar');
    if (!bar) return;
    if (!machine) {
      bar.innerHTML = '<div class="sxsn-fb"><span class="sxsn-fb-ico">' + CAR + '</span>'
        + '<div class="sxsn-fb-txt">See which parts fit your machine<small>Add your make, model and year once. Every part shows a fit check.</small></div>'
        + '<a class="sxsn-fb-cta" href="/pages/my-garage">Add my machine</a></div>';
      return;
    }
    var on = prefOn();
    var label = esc(G().formatLabel(machine));
    var ask = '<a class="sxsn-fb-link" href="sms:+17194286837?body=Will%20this%20fit%20my%20' + encodeURIComponent(G().formatLabel(machine)) + '%3F">text us to check</a>';
    var summary;
    if (on) {
      var shown = counts.fits + counts.universal;
      summary = shown + ' part' + (shown === 1 ? '' : 's') + ' listed for your machine'
        + (scan.scanning ? ' — checking page ' + scan.done + ' of ' + scan.total + '…'
                         : (scan.total > 1 ? ' across ' + scan.total + ' page' + (scan.total === 1 ? '' : 's') : ''))
        + (scan.capped ? ' (first ' + scan.total + ' pages)' : '')
        + (counts.gear ? '. Gear, apparel & tools (' + counts.gear + ') stay shown' : '')
        + (counts.unknown ? '. ' + counts.unknown + ' from brands that don’t publish fitment are hidden — ' + ask : '');
    } else {
      var parts = [counts.fits + ' fit'];
      if (counts.universal) parts.push(counts.universal + ' universal');
      parts.push(counts.nofit + ' don’t fit');
      if (counts.unknown) parts.push(counts.unknown + ' not listed by the maker');
      if (counts.gear) parts.push(counts.gear + ' gear & tools');
      summary = parts.join(' · ') + ' on this page';
    }
    var pic = machine.photo_url && /^(https?:|data:image\/|\/)/.test(String(machine.photo_url))
      ? '<img class="sxsn-fb-pic" src="' + esc(machine.photo_url) + '" alt="" width="56" height="56" loading="lazy">'
      : '<span class="sxsn-fb-ico">' + CAR + '</span>';
    bar.innerHTML = '<div class="sxsn-fb">' + pic
      + '<div class="sxsn-fb-txt" id="sxsn-fb-label">Show only parts that fit my ' + label + '<small>' + summary + '</small></div>'
      + '<button type="button" class="sxsn-fb-sw" role="switch" aria-labelledby="sxsn-fb-label" aria-checked="' + (on ? 'true' : 'false') + '"><span></span></button>'
      + '<a class="sxsn-fb-link" href="/pages/my-garage">Change machine</a></div>'
      + (on && !scan.scanning && (counts.fits + counts.universal) === 0
          ? '<div class="sxsn-fb-empty">Nothing in this collection is listed for your ' + label + ' yet. Turn the switch off to see everything, or ' + ask + '.</div>' : '');
    bar.querySelector('.sxsn-fb-sw').addEventListener('click', function () {
      setPref(!prefOn());
      apply();
      if (prefOn()) scanPages();
    });
  }

  function reorder(grid, on) {
    var items = Array.prototype.slice.call(grid.querySelectorAll(':scope > li.grid__item'));
    items.forEach(function (li, i) { if (!li.hasAttribute('data-sxsn-order')) li.setAttribute('data-sxsn-order', i); });
    var rank = function (li) {
      if (!on) return 0;
      if (li.classList.contains('sxsn-fit-fits')) return 0;
      if (li.classList.contains('sxsn-fit-universal')) return 1;
      return 2;
    };
    items.sort(function (a, b) {
      return (rank(a) - rank(b)) || (+a.getAttribute('data-sxsn-order') - +b.getAttribute('data-sxsn-order'));
    }).forEach(function (li) { grid.appendChild(li); });
  }

  var scan = { scanning: false, done: 0, total: 1, capped: false, started: false };
  var MAX_PAGES = 30;

  function scanPages() {
    var bar = document.getElementById('sxsn-fit-bar');
    var grid = document.getElementById('product-grid');
    if (!bar || !grid || scan.started) return;
    // page count from the theme's pagination links; section id from the grid (both survive filter re-renders)
    var pages = 1;
    Array.prototype.forEach.call(document.querySelectorAll('#ProductGridContainer .pagination a, #ProductGridContainer .pagination span'), function (el) {
      var v = parseInt((el.textContent || '').trim(), 10);
      if (!isNaN(v) && v > pages) pages = v;
    });
    var cur = parseInt(new URL(location.href).searchParams.get('page') || '1', 10) || 1;
    var sid = grid.getAttribute('data-id');
    scan.total = Math.min(pages, MAX_PAGES);
    scan.capped = pages > MAX_PAGES;
    if (pages <= 1 || !sid || !window.fetch || !window.DOMParser) { scan.started = true; return; }
    scan.started = true; scan.scanning = true; scan.done = 1;
    var todo = [];
    for (var n = 1; n <= scan.total; n++) if (n !== cur) todo.push(n);
    var running = 0, idx = 0;
    function next() {
      if (idx >= todo.length) { if (running === 0) { scan.scanning = false; apply(); } return; }
      var n = todo[idx++]; running++;
      var u = new URL(location.href);
      u.searchParams.set('page', n); u.searchParams.set('section_id', sid);
      fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = document.getElementById('product-grid');
        if (!g) return;
        Array.prototype.forEach.call(doc.querySelectorAll('#product-grid > li.grid__item[data-sxsn-fd]'), function (li) {
          li.setAttribute('data-sxsn-extra', '1');
          li.setAttribute('data-sxsn-order', String(n * 1000 + Array.prototype.indexOf.call(li.parentNode.children, li)));
          li.classList.remove('scroll-trigger', 'animate--slide-in');
          g.appendChild(document.importNode(li, true));
        });
      }).catch(function () {}).then(function () {
        running--; scan.done++;
        apply();
        next();
      });
    }
    next(); next(); next();
  }

  var applying = false;
  function apply() {
    var g = G();
    var bar = document.getElementById('sxsn-fit-bar');
    var grid = document.getElementById('product-grid');
    if (!g || !bar) return;
    applying = true;
    injectCss();
    var machine = primary();
    var on = !!machine && prefOn();
    document.body.classList.toggle('sxsn-fit-on', on);
    var counts = { fits: 0, universal: 0, nofit: 0, unknown: 0, gear: 0 };
    if (grid) {
      Array.prototype.forEach.call(grid.querySelectorAll('li.grid__item[data-sxsn-fd]'), function (li) {
        var old = li.querySelector(':scope > .sxsn-fitchip');
        if (old) old.remove();
        li.classList.remove('sxsn-fit-fits', 'sxsn-fit-universal', 'sxsn-fit-nofit', 'sxsn-fit-unknown', 'sxsn-fit-gear');
        if (!machine) return;
        var c = classify(li, machine);
        if (on || !li.hasAttribute('data-sxsn-extra')) counts[c.state]++;
        li.classList.add('sxsn-fit-' + c.state);
        var html = chipHtml(c);
        if (html) li.insertAdjacentHTML('afterbegin', html);
      });
      reorder(grid, on);
    }
    renderBar(machine, counts);
    setTimeout(function () { applying = false; }, 0);
  }

  function watchGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || !window.MutationObserver) return;
    var queued = false;
    new MutationObserver(function () {
      if (applying || queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        var g = document.getElementById('product-grid');
        if (g && !g.querySelector('li[data-sxsn-extra]')) { scan = { scanning: false, done: 0, total: 1, capped: false, started: false }; }
        apply();
        if (primary() && prefOn()) scanPages();
      }, 30);
    }).observe(container, { childList: true, subtree: true });
  }

  function start() {
    if (!document.getElementById('sxsn-fit-bar')) return;
    if (!G()) { // garage-data.js is deferred site-wide; wait for it
      var tries = 0;
      var t = setInterval(function () { if (G() || ++tries > 40) { clearInterval(t); if (G()) start(); } }, 100);
      return;
    }
    apply();
    if (primary() && prefOn()) scanPages();
    watchGrid();
    if (G().onChange) G().onChange(apply);
    window.addEventListener('sxsn:garage-restored', apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
